<template>
    <div>
        <!-- <div :class="customClass" :id='randomId' :style="'width: 100%; height:' + this.height + 'px;'"></div> -->
        <div
        id="map"
        :style="'width: 100%; height:' + this.height + 'px;'"
        class="rounded-xl"
        :class="customClass"
        ></div>
    </div>
</template>

<script>
export default {
    props: {
        markers: {
            type: Array,
        },
        selectedMarker: {
            type: Object,
        },
        selectedMarkerZoom: {
            default: 12
        },
        position: {
            type: Object
        },
        customClass: {
            type: String
        },
        height: {
            default: 400
        },
        zoom: {
            default: 5
        },
        home: {}
    },
    data() {
        return {
            markersObjects: [],
            mapObject: null,
            markerLabels: []
            // randomId: null,
            // markerElements: [],
            // markerColor: "#50acde"
        }
    },
    watch: {
        markers: function(value) {
            this.initMap()
        },
        selectedMarker: function(value) {
            // Close all labels
            this.markerLabels.forEach((label) => {label.close();})

            if (value) {
                this.markersObjects.forEach((marker) => marker.setOptions({'opacity': 0.3}))
                this.mapObject.setCenter({lat: parseFloat(value.latitude), lng: parseFloat(value.longitude)})
                this.mapObject.setZoom(this.selectedMarkerZoom)
                const currentMarker = this.markersObjects.find((marker) => marker.meta.id == value.data.id)
                const currentLabel = this.markerLabels.find((marker) => marker.id == value.data.id)
                if (currentMarker && currentLabel) {
                    const map = this.mapObject
                    currentLabel.open({
                        anchor: currentMarker,
                        map,
                    });
                    currentMarker.setOptions({'opacity': 1})
                }


                // this.mapObject.setCenter(myLatLng)
                // this.markersObjects.forEach((markerObj) => {
                //     if (markerObj.position.lng() != value.longitude && markerObj.position.lat() != value.latitude) {
                //         markerObj.setMap(null)
                //     }
                // })
            } else {
                this.markersObjects.forEach((marker) => marker.setOptions({'opacity': 1}))
            }
        }
    },
    computed: {
        positionData() {
            if (!this.position) {
                return {
                    longitude: "1.7191036",
                    latitude: "46.71109",
                    zoom: this.zoom
                }
            }
            return this.position
        }
    },
    methods: {
        initMap() {
            const myLatLng = {lat: parseFloat(this.positionData.latitude), lng: parseFloat(this.positionData.longitude)};

            this.mapObject = new google.maps.Map(document.getElementById("map"), {
                center: new google.maps.LatLng(parseFloat(this.positionData.latitude), parseFloat(this.positionData.longitude)),
                zoom: this.positionData.zoom,
                center: myLatLng,
            });

            this.setMarkers()
        },

        setMarkers() {
            const map = this.mapObject
            let myLatLng = null
            const defaultMarkers = this.markers
            let self = this

            defaultMarkers.forEach((marker, index) => {
                myLatLng = {lat: parseFloat(marker.latitude), lng: parseFloat(marker.longitude)};
                if (myLatLng.lng && myLatLng.lat) {
                    // Create marker
                    let gMarker = new google.maps.Marker({
                        position: myLatLng,
                        map,
                        meta: marker.data,
                        id: marker.id,
                        animation: google.maps.Animation.DROP,
                    });
                    this.markersObjects.push(gMarker)

                    // Get click on marker
                    google.maps.event.addListener(gMarker, 'click', (function(marker, i) {
                        return () => {
                            // infowindow.setContent(locations[i][0]);
                            // infowindow.open(map, marker);
                            const selectedMarker = defaultMarkers.find((marker) => marker.id == gMarker.id)
                            if (selectedMarker) {
                                self.$emit('marker-clicked', selectedMarker)
                            }
                        }
                    })(gMarker, index));

                    // Set Labels
                    this.markerLabels.push(new google.maps.InfoWindow({
                        id: marker.data.id,
                        content: marker.label,
                        ariaLabel: "Uluru",
                    }))

                }
            })

            if (this.home) {
                myLatLng = {lat: parseFloat(this.home.latitude), lng: parseFloat(this.home.longitude)};
                new google.maps.Marker({
                    position: myLatLng,
                    map,
                    icon: 'https://disticloudfiles.net/img/savinfo/default/home_marker.png'
                });
            }
        }
    },
    mounted() {
        this.initMap()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavMap.vue